// Complete Text config to use to render text assets in a specific page

const pageTextConfig = {
    // form container 
    form: {
        formRight: {
            title: "Create Account",
            formText: "or use your email for registration",
            registerButtonText: "Register",
        },
        formleft: {
            title: "Login",
            formText: "or use your account",
            loginButtonText: "Login",
        }
    },

    // overlay container
    overlay: {
        overlayRight: {
            title: "New To GenieGig?",
            paragraphText: "Create your account with us now and start your journey!!",
            signUpButtonText: "Go To Register Page"    
        },
        overlayLeft: {
            title: "Already have an account?",
            paragraphText: "Login with your existing account and start exploring rightaway!!",
            signInButtonText: "Go To Login Page"    
        }

    },

}

export default pageTextConfig